<template>
  <div class="fair-survey-step fair-survey-step--centered">
    <div class="fair-survey-step__head fair-survey-step__head--centered">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p class="fair-survey-step__subtitle completion-step__text">
        По вашим ответам мы собрали подборку подарков — она уже ждёт вас.
      </p>
    </div>

    <p
      v-if="giftStore.giftModal.isLoading"
      class="fair-survey-step__note"
    >
      Формируем подборку…
    </p>
    <FairButton
      v-else
      class="completion-step__cta"
      label="Перейти к подборке"
      variant="primary"
      size="m"
      :rounded="false"
      @click="handleAction"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { FairButton } from '@/ui/primitives/FairButton'
import { useGiftModal } from '@/features/gift/store'
import type { GiftStep } from '@/features/gift/types/gift-config'

interface Props {
  step: GiftStep & { type: 'completion' }
}

const props = defineProps<Props>()
const giftStore = useGiftModal()


async function handleAction() {
  // Экшн будет добавлен пользователем позже
  // Здесь можно использовать giftStore.giftModal.resultLink для навигации
}

onMounted(async () => {
  // Отправляем данные на бекенд при переходе на этот шаг
  try {
    await giftStore.submitGiftSurvey()
  } catch (error) {
    console.error('Error submitting gift survey:', error)
  }
})
</script>

<style scoped>
.fair-survey-step--centered {
  justify-content: center;
  align-items: center;
}

.completion-step__text {
  max-width: 480px;
  text-align: center;
}

.completion-step__cta {
  align-self: center;
}
</style>
